import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { HiOutlineLogout } from 'react-icons/hi';
import './Navbar.css';

const Navbar = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [time, setTime] = useState(new Date());

  useEffect(() => {
    const timer = setInterval(() => setTime(new Date()), 1000);
    return () => clearInterval(timer);
  }, []);

  const handleLogout = () => {
    localStorage.removeItem('isLoggedIn');
    window.location.href = "/"; // Force reload to clear state
  };

  const formatTime = (date) => {
    const optionsDate = { weekday: 'long', day: 'numeric', month: 'short', year: 'numeric' };
    const optionsTime = { hour: '2-digit', minute: '2-digit', hour12: false };
    return {
      date: date.toLocaleDateString('id-ID', optionsDate),
      time: date.toLocaleTimeString('id-ID', optionsTime).replace('.', ':') + ' WIB'
    };
  };

  const current = formatTime(time);

  return (
    <nav className="main-navbar">
      <div className="nav-brand">
        <img src="/assets/logo-agrid.png" alt="Agrid" />
      </div>
      
      <div className="nav-links">
        <Link to="/beranda" className={location.pathname === '/beranda' ? 'active' : ''}>Beranda</Link>
        <Link to="/dashboard" className={location.pathname === '/dashboard' ? 'active' : ''}>Dashboard</Link>
        <Link to="/riwayat" className={location.pathname === '/riwayat' ? 'active' : ''}>Riwayat</Link>
        <Link to="/tentangkami" className={location.pathname === '/tentangkami' ? 'active' : ''}>Tentang Kami</Link>
      </div>

      <div className="nav-status">
        <div className="time-container">
          <div className="date-row">{current.date}</div>
          <div className="time-row">{current.time}</div>
        </div>
        <button onClick={handleLogout} className="nav-logout">
          <HiOutlineLogout />
        </button>
      </div>
    </nav>
  );
};

export default Navbar;